// Minimal pub-sub so axiosInterceptor.tsx (a plain module, not a React component) can
// tell the globally-mounted PermissionDeniedModal to show itself. Deliberately not
// Zustand here — per CLAUDE.md that's scoped to the new dashboards only.
type Listener = () => void
const listeners: Listener[] = []

export const onPermissionDenied = (cb: Listener) => {
  listeners.push(cb)
  return () => {
    const i = listeners.indexOf(cb)
    if (i !== -1) listeners.splice(i, 1)
  }
}

export const notifyPermissionDenied = () => listeners.forEach((cb) => cb())
